import { api } from "boot/axios";

let cachedWhoAmI = null;
let whoAmIPromise = null;

export default () => {
  //Get User
  const whoAmI = async () => {
    if (cachedWhoAmI) {
      return cachedWhoAmI;
    }
    if (whoAmIPromise) {
      return whoAmIPromise;
    }
    try {
      whoAmIPromise = api.get("/accounts/user/whoami/");
      const data = await whoAmIPromise;
      cachedWhoAmI = data;
      whoAmIPromise = null;
      return data;
    } catch (error) {
      throw new Error(error);
    }
  };

  //Update User
  const updateWhoAmI = async (info) => {
    try {
      const data = await api.patch("/accounts/update/", info);
      cachedWhoAmI = null;
      return data;
    } catch (error) {
      throw new Error(error);
    }
  };

  //Update Password
  const updatePassword = async (password) => {
    try {
      const data = await api.post("/accounts/password/change/", password);

      return data;
    } catch (error) {
      throw error;
    }
  };

  // Delete Account
  const deleteAccountRequest = async (payload) => {
    try {
      const data = await api.post("/accounts/delete/user/", payload);
      cachedWhoAmI = null;
      return data;
    } catch (error) {
      throw error;
    }
  };
  // Undo Delete
  const undoAccountDelete = async () => {
    try {
      const data = await api.delete("/accounts/delete/user/");
      cachedWhoAmI = null;
      return data;
    } catch (error) {
      throw error;
    }
  };

  const clearUserCache = () => {
    cachedWhoAmI = null;
  };

  return {
    deleteAccountRequest,
    undoAccountDelete,
    whoAmI,
    updateWhoAmI,
    updatePassword,
    clearUserCache,
  };
};
